export const TenantTableHeader = [
  
  {
    id: "1",
    align: "left",
    width: "10px",
    label: "",
  },
 
  {
    id: "3",
    align: "left",
    width: "150px",
    label: "Template Name",
  },
  {
    id: "5",
    align: "center",
    width: "450px",
    label: "Subscription Plan Name",
  },
  {
    id: "4",
    align: "center",
    width: "450px",
    label: "Template type",
  },
  {
    id: "6",
    align: "left",
    width: "100px",
    label: "Action",
  }
];
export const TenantTemplateTableHeader = [
  {
    id: "0",
    align: "start",
    width: "10px",
    label: "",
  },
  
  {
    id: "1",
    align: "start",
    width: "150px",
    label: "Template Name",
  },
  {
    id: "2",
    align: "center",
    width: "450px",
    label: "Code",
  },
  {
    id: "3",
    align: "center",
    width: "450px",
    label: "Template type",
  },
  {
    id: "4",
    align: "start",
    width: "100px",
    label: "Action",
  },
];
export const TenantChatBotTableHeader = [

  {
    id: "1",
    align: "left",
    width: "10px",
    label: "",
  },
  {
    id: "1",
    align: "left",
    width: "150px",
    label: "Template Name",
  },
  {
    id: "2",
    align: "center",
    width: "450px",
    label: "Code",
  },
  {
    id: "4",
    align: "center",
    width: "450px",
    label: "Template type",
  },
  {
    id: "3",
    align: "left",
    width: "100px",
    label: "Action",
  }
];
export const TenantChatBotTableHeaderMearge = [

  {
    id: "0",
    align: "left",
    width: "10px",
    label: "",
  },
  {
    id: "1",
    align: "left",
    width: "150px",
    label: "Template Name",
  },
  {
    id: "2",
    align: "left",
    width: "450px",
    label: "Code",
  },
  {
    id: "3",
    align: "center",
    width: "450px",
    label: "Template type",
  },
  {
    id: "4",
    align: "left",
    width: "100px",
    label: "Action",
  }
];